import React from 'react';

const mediaOutlets = [
  { name: 'Yahoo Finance', logo: '/logos/YahooFinance.png' },
  { name: 'Bloomberg', logo: null, display: 'Bloomberg' },
  { name: 'Proactive', logo: null, display: 'Proactive' },
  { name: 'Markets Insider', logo: '/logos/MarketInsider.png' },
];

const MediaSection = () => {
  return (
    <section 
      className="py-10 bg-white border-t border-gray-200"
      data-testid="media-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col items-center">
          <span className="text-gray-400 text-sm italic mb-6">As Seen On:</span>
          <div className="flex flex-wrap items-center justify-center gap-10 md:gap-14">
            {mediaOutlets.map((outlet) => (
              <div 
                key={outlet.name}
                className="opacity-70 hover:opacity-100 transition-opacity"
                data-testid={`media-logo-${outlet.name.toLowerCase().replace(/\s/g, '-')}`}
              >
                {outlet.logo ? (
                  <img 
                    src={outlet.logo} 
                    alt={outlet.name}
                    className="h-8 md:h-10 w-auto object-contain"
                  />
                ) : (
                  <span className="text-gray-500 text-sm md:text-base font-medium">
                    {outlet.display}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaSection;
